const u = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1400&q=80`;

export const IMG = {
  hero: u("photo-1623073284779-38f757e78dcd"),
  table: u("photo-1664994464799-c8f643d712f6"),
  chef: u("photo-1651948512032-8b4d4b37fe74"),
  app1: u("photo-1680342630889-b475e612a058"),
  app2: u("photo-1680342627018-1cfc75d0597a"),
  waiter: u("photo-1719786625035-71f46082e385"),
  dessert: u("photo-1769812343875-c40f9ec7f846"),
  molecular: u("photo-1672149945890-6e8e96c1536c"),
  hot: u("photo-1599921841143-819065a55cc6"),
  salad: u("photo-1757596057470-19d36962705d"),
  cold: u("photo-1567496295302-b8dbcd2913b6"),
  wedding: u("photo-1616668856493-9df876327739"),
  party: u("photo-1699730148440-22fc68a96752"),
  garden: u("photo-1564638305579-5e395c9b62c7"),
  buffet: u("photo-1555244162-803834f70033"),
  family: u("photo-1669130183473-3a4c8524082f"),
};

export const CONTACT = {
  email: "info@jenjednoslovo.cz",
  phone: "+420 725 340 166",
  ico: "04040325",
};

export const OCCASIONS = [
  { code: "01", title: "Svatby", text: "Teplá jídla, saláty i studené mísy pro celý svatební den.", img: IMG.wedding, span: "md:col-span-4 md:row-span-2" },
  { code: "02", title: "Oslavy & jubilea", text: "Narozeniny, výročí, promoce. Hostina, na kterou se nezapomíná.", img: IMG.party, span: "md:col-span-2" },
  { code: "03", title: "Zahradní párty", text: "Křidélka, stehýnka, saláty a mísy pod širým nebem.", img: IMG.garden, span: "md:col-span-2" },
  { code: "04", title: "Firemní akce", text: "Rauty pro kolegy i obchodní partnery. Precizně a včas.", img: IMG.buffet, span: "md:col-span-3" },
  { code: "05", title: "Rodinné slávy", text: "Poctivé domácí jídlo pro rodinu a přátele přímo u vás.", img: IMG.family, span: "md:col-span-3" },
];

export const MENU = [
  { key: "tepla", label: "Teplá jídla", img: IMG.hot, items: ["Vepřové řízečky", "Kuřecí řízečky", "Pikantní křidélka", "Pečené stehýnka", "Hovězí guláš", "Katův šleh", "Játra na cibulce", "Pečený losos"] },
  { key: "salaty", label: "Saláty", img: IMG.salad, items: ["Těstovinový salát – zeleninový", "Těstovinový salát – masová variace", "Salát „coleslaw“", "Salát „zelný“", "Salát „ovocný“", "Bramborový salát", "Pařížský salát"] },
  { key: "studena", label: "Studená kuchyně", img: IMG.cold, items: ["Hovězí tatarák + topinky", "Mini tortila", "Ovocná mísa", "Uzeninová mísa", "Sýrová mísa", "Mísa rajče + mozzarella", "Sýrová pomazánka", "Škvarková pomazánka"] },
];

export const STEPS = [
  { n: "01", title: "Jedno slovo", text: "Napíšete nám, co slavíte. Stačí pár vět ve formuláři." },
  { n: "02", title: "Výběr jídel", text: "V nabídce zaškrtnete jídla, která vám chutnají. Vše se přidá do poptávky." },
  { n: "03", title: "Cenová nabídka", text: "Podle vybraných jídel a počtu hostů vám připravíme cenu na míru." },
  { n: "04", title: "Realizace", text: "Přivezeme, připravíme, obsloužíme a uklidíme. Vy slavíte." },
];

export const EVENT_TYPES = ["Svatba", "Oslava", "Zahradní párty", "Firemní akce", "Soukromá večeře", "Jiné"];
